import Backdrop from '@mui/material/Backdrop';
import React, { useState } from "react";
import animationData from "../images/UnitedLoder.json";
import Lottie from "react-lottie";

const Loader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Backdrop
      sx={{
        // backgroundColor: "transparent",
        cursor: "progress",
        zIndex: (theme) =>
          Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
      }}
      open={true}
    >
      <Lottie
        isClickToPauseDisabled={true}
        options={defaultOptions}
        height={250}
        width={250}
      />
    </Backdrop>
  );
};

export default Loader;
